<template>
  <v-img :alt="`${name} Logo`" class="shrink mr-2" contain :src="logo" position="center left" transition="scale-transition" :width="width"/>
</template>

<script lang="ts">
import Vue from "vue";
import { createHelpers } from "vuex-typescript-interface";
import { ThemeStoreInterface } from "@/store/theme/types";
const { mapGetters } = createHelpers<ThemeStoreInterface>();
const getters = mapGetters(["logo", "name"]);

export default Vue.extend({
  name: "AppBarLogo",
  props: {
    width: {
      type: String,
      default: '196'
    }
  },
  computed: {
    ...getters
  }
});
</script>
<style scoped>
.v-image {
  max-height: 60px;
}
</style>
